export default function generateLpMeta({
    sectionTitle,
    article: {
        tags = [],
        authors = [],
        links: { shareUrl },
        changes: { published },
        characteristics: { hotness } = {},
        clientProperties: { wordcount },
    },
    layout,
}) {
    const lpMeta = [
        {
            property: 'article:section',
            content: sectionTitle,
        },
        {
            property: 'article:published_time',
            content: published,
        },
    ];

    if (shareUrl) {
        lpMeta.push({
            property: 'lp:url',
            content: shareUrl,
        });
    }

    if (hotness) {
        lpMeta.push({
            property: 'lp.article:score',
            content: Math.floor(hotness / 10),
        });
    }

    if (wordcount) {
        lpMeta.push({
            property: 'lp:wordcount',
            content: wordcount,
        });
    }

    if (layout === 'promo') {
        lpMeta.push({
            property: 'lp:paywall',
            content: 'hard',
        });
    }

    return lpMeta
        .concat(
            tags.map((tag) => ({
                property: 'article:tag',
                content: tag.title,
            })),
        )
        .concat(
            authors.map((author) => ({
                property: 'og:author',
                content: author.title,
            })),
        );
}



/** WEBPACK FOOTER **
 ** ./src/utils/get-lp-meta.js
 **/